export default [
  {
    component: () => import('./pages/Entry.vue'),
    beforeEnter: (to, from, next) => {
      if (!to.query.slug) {
        next({ path: '/404' });
      } else {
        next();
      }
    },
    meta: {
      metaTags: [
        {
          content: 'Quota Reached. Upgrade to continue.',
          name: 'description',
        },
        {
          page_slug: 'upgrade',
        },
      ],
      requiresAuth: true,
      title: 'eRank — Upgrade',
    },
    name: 'upgrade',
    path: '/upgrade',
  },
];
    